<template>
    <div class="p-3 info-block"><i :class="icon"></i> <span v-html="message"></span></div>
</template>
<script>
export default {
  name: "info-message",
  props: {
    icon: {
      type: String,
      default: "fas fa-info",
    },
    message: {
      type: String,
      default: "",
    },
  }
};
</script>
<style>
</style>
